import { enhanceAppHypertaskUrl } from './redirect-utils'
import { getUTMDataFromCookies } from './utm-utils'

// Mock axios for testing all 3 flows
export const mockAxios = {
  post: async (url: string, email: string) => {
    console.log("🚀 ~ url:", url)
    // Simulate network delay
    // await new Promise(resolve => setTimeout(resolve, 1000))
    
    // Get UTM data from cookies
    const utmData = getUTMDataFromCookies();
    console.log("🚀 ~ utmData:", utmData)
    
    // Mock successful responses
    if (url.includes('instant-signup')) {
      // For instant login, also make the actual API call with UTM data
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          email: email,
          utmData: utmData 
        }),
      })

      const data = await response.json()
      console.log('📧 Mock: Instant login for', email, 'with UTM data:', utmData)
      return {
        status: response.status,
        data: data
      }
    } else if (url.includes('send-email-link')) {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          email: email,
          utmData: utmData 
        }),
      })

      const data = await response.json()
      console.log("🚀 ~ data:", data)
      console.log('📧 Mock: Email signup for', email, 'with UTM data:', utmData)
      return {
        status: 200,
        data: { success: true, message: 'Magic link sent' }
      }
    }
    
    throw new Error('Unknown endpoint')
  }
}

/**
 * Handles instant login flow - calls API and returns enhanced redirect URL
 * 
 * @param email - User's email address
 * @param posthogInstance - Optional PostHog instance for session tracking
 * @returns Promise that resolves to the enhanced redirect URL
 * @throws Error if API call fails or loginUrl is missing
 */
export async function handleInstantLogin(
  email: string,
  posthogInstance?: { get_session_id?: () => string | undefined | null }
): Promise<string> {
  console.log('🚀 Instant login flow for:', email)
  
  const response = await mockAxios.post('https://app.hypertask.ai/api/auth/instant-signup', email.trim())
  
  if (response.status !== 200) {
    throw new Error('Failed to sign in. Please try again.')
  }
  
  // Get loginUrl from response
  const loginUrl = response.data?.loginUrl
  if (!loginUrl) {
    throw new Error('No login URL received from server. Please try again.')
  }
  
  // Enhance the login URL with PostHog session ID and UTM params
  console.log('✅ Instant login successful, preparing redirect...')
  const enhancedUrl = enhanceAppHypertaskUrl(loginUrl, posthogInstance)
  
  return enhancedUrl
}

/**
 * Handles email signup flow (basic/lean variants) - calls API and returns success status
 * 
 * @param email - User's email address
 * @returns Promise that resolves to true if successful
 * @throws Error if API call fails
 */
export async function handleEmailSignup(email: string): Promise<boolean> {
  console.log('📧 Email signup flow for:', email)
  
  const response = await mockAxios.post('https://app.hypertask.ai/api/auth/send-email-link', email.trim())
  
  if (response.status !== 200) {
    throw new Error('Failed to sign up. Please try again.')
  }
  
  console.log('✅ Email signup successful')
  return true
}

